const setMetaTag = (attr, key, content) => {
  let m = document.querySelector(`meta[${attr}="${key}"]`);
  if (!m) {
    m = document.createElement("meta");
    m.setAttribute(attr, key);
    document.head.appendChild(m);
  }
  m.setAttribute("content", content);
};

export const setPageMeta = (title, description, opts = {}) => {
  document.title = title;
  if (description) setMetaTag("name", "description", description);
  const og = opts.og || {};
  if (og.title) setMetaTag("property", "og:title", og.title);
  if (og.description) setMetaTag("property", "og:description", og.description);
  if (og.image) setMetaTag("property", "og:image", og.image);
  if (opts.robots) {
    setMetaTag("name", "robots", opts.robots);
  } else {
    document.querySelector('meta[name="robots"]')?.remove();
  }
};
